
import Scissor1 from "../../../assets/duotone/Scissor1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Scissor1Icon({ className, dataTestid = "Scissor1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Scissor1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
